import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CourseSessionViewModel } from 'app/pages/attendance/viewModels/CourseSessionViewModel';
import { CourseRunParticipantsViewModel } from 'app/viewModels/CourseRunParticipantsViewModel';
import { ApiService } from 'app/_services/api.service';
 


@Component({
  selector: 'app-course-sign-in-modal',
  templateUrl: './course-sign-in-modal.component.html',
  styleUrls: ['./course-sign-in-modal.component.scss']
})
export class CourseSignInModalComponent implements OnInit {
  _participant:CourseRunParticipantsViewModel;
 
  @Input() show:Boolean;
  @Output() onClose:EventEmitter<any>= new EventEmitter<any>() ;

  @Input() 
  set participant(value:CourseRunParticipantsViewModel){
    this._participant = value;    
    if(value)
    this.signInForm.patchValue(value);
    if(value && value.courseRunBooking.signInTimeOfReturn)
    this.signInForm.patchValue({signInTimeOfReturn:value.courseRunBooking.signInTimeOfReturn.split(" ")[0]});

  }

  signInForm:FormGroup;
  constructor(private apiSvc: ApiService,
    private _fb : FormBuilder

    ) {       
    this.signInForm = this._fb.group({        
      signInDate:[],
      signInMissAction:[''],
      signInContactNumber:[''],
      signInTimeOfReturn:[''],      
    });

  }

  ngOnInit() {
  }

  handleSignIn(){
    if(this.signInForm.valid)
      this.apiSvc.signInCourseRun(this._participant.courseRunBooking.id,this.signInForm.value)
      .subscribe(res=>{
        this.show=false;        
        this.handleClose(res);
      })
  }

  handleClose(val){
    if(this.onClose)
    this.onClose.next(val);
  }
}
